import {useFormik} from 'formik';
import {useState} from 'react';
import {useProjectStoryById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {dateTimeParse} from '@gravity-ui/date-utils';
import {DateTime} from '@gravity-ui/date-utils';
import {ProjectStoryModel} from '../../../entities';

type UseEditProjectStoryFormProps = {
  storyId: string | null;
  setOpen: (open: boolean) => void;
  story?: ProjectStoryModel;
};

export const useEditProjectStoryForm = ({storyId, setOpen, story}: UseEditProjectStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateProjectStoryMutation} = useProjectStoryById(storyId || '');

  const onSubmit = async (values: {title: string; priority: number; date: DateTime | null}) => {
    if (!storyId || !values.date) return;

    setErrorMessage(null);
    try {
      await updateProjectStoryMutation.mutateAsync({
        storyId,
        dto: {
          title: values.title,
          priority: values.priority,
          date: values.date.format('YYYY-MM-DD'),
        },
      });
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении новости проекта');
    }
  };

  const handleDateChange = (date: DateTime | null) => {
    formik.setFieldValue('date', date);
  };

  const formik = useFormik({
    initialValues: {
      title: story?.title || '',
      priority: story?.priority || 0,
      date: (story?.date ? dateTimeParse(story.date) : null) as DateTime | null,
    },
    validationSchema: Yup.object({
      title: Yup.string().required('Заголовок обязателен'),
      priority: Yup.number().required('Приоритет обязателен'),
      date: Yup.mixed().required('Дата обязательна'),
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    handleDateChange,
    isLoading: updateProjectStoryMutation.isPending,
    submitError: updateProjectStoryMutation.error
      ? (updateProjectStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
